module.exports = __webpack_public_path__ + "media/images/institute-b7a27c458b922d3fa42f2a500011cd48.jpg";